::ng-deep particle-jurisdiction-cell-viewer{width:100%}::ng-deep particle-jurisdiction-cell-viewer i{color:var(--accent, #175CFF)!important;font-size:1rem}
/*# sourceMappingURL=jurisdiction-cell-viewer.component-YEDW2U5T.css.map */
